import { ZoomVideoService } from "../zoom-video.service";

export const PARTICIPANT_CHANGE_TYPE = {
    ADD: "add",
    REMOVE: "remove",
};

export const PEER_VIDEO_STATE_CHANGE_ACTION_TYPE = {
    Start: "Start",
    Stop: "Stop",
};
const page = 0;
const pageSize = 5;

export const handleParticipantsChange = async (
    participants: any[],
    renderedList: any[],
    videoService: ZoomVideoService,
) => {
    const pageParticipants = participants.filter(
        (user, index) => Math.floor(index / pageSize) === page,
    );
    const videoParticipants = pageParticipants.filter((user) => user.bVideoOn);
    /** For performance reasons, the SDK can only render 9 videos at the same time. We recommend that you stop rendering the old video and then render a new video. * */
    const removedVideoParticipants = renderedList.filter(
        (user) =>
            videoParticipants.findIndex(
                (user2) => user2.userId === user.userId,
            ) === -1,
    );
    if (removedVideoParticipants.length > 0) {
        removedVideoParticipants.forEach(async (user) => {
            await videoService.toggleParticipantVideo(false, user.userId);
        });
    }
    const addedVideoParticipants = videoParticipants.filter(
        (user) =>
            renderedList.findIndex((user2) => user2.userId === user.userId) ===
            -1,
    );
    if (addedVideoParticipants.length > 0) {
        addedVideoParticipants.forEach(async (user) => {
            // render new video
            await videoService.toggleParticipantVideo(
                user.bVideoOn,
                user.userId,
            );
        });
    }
    return videoParticipants;
};
